import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          合作、投稿与问题反馈通道
        </p>

        <div className="max-w-[700px] mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">
            {contactData.description}
          </p>

          <div className="flex items-center gap-3 mb-6 p-4 bg-background-100 rounded-xl">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <div>
              <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
              <span className="text-sm font-semibold text-foreground-800">{contactData.email}</span>
            </div>
          </div>

          <div className="space-y-2.5">
            {contactData.tips.map((tip, i) => (
              <div key={i} className="flex items-start gap-2.5 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
                </span>
                <span>{tip}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}